import React, {
  ChangeEvent,
  Dispatch,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import closeIco from "../../assets/close-icon-color.png";
import { ItemTypes, PopupsListType } from "./RightSideMenu";
import AvailableRiverSensors from "../../riverSensors/AvailableRiverSensors";
import RiverSensorLocation from "../../riverSensors/RiverSensorLocation";
import RiverSensorChart from "../../riverSensors/RiverSensorChart";
import { ResizeCallbackData } from "react-resizable";
import { openWindowsMapRiver, riverMap } from "../../riverSensors/RiverSensors";
import SideRiverChart from "../../riverSensors/SideRiverChart";
import ReactDOM from "react-dom";
import SensorsPopUp from "../../riverSensors/SensorsPopUp";
import Overlay from "ol/Overlay";
import { map } from "../../mainLayer/MainLayer";
import { Coordinate } from "ol/coordinate";
import { useRiverContext } from "../../provider/RiverProvider";
import ForcastChart from "../../riverSensors/ForcastChart";
import loadImageBlue from "../../assets/ai-load-blue.gif";
import loadImageWhite from "../assets/ai-load-white.gif";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Paper } from "@mui/material";


type SetupDateType = {
  startDate: Date;
  endDate: Date;
};

type SensorDataType = {
  title: string;
  description: string;
};

type SideMenuPopupsType = {
  id: string;
  name: string;
  critical: number;
  cautious: number;
  warning: number;
  setPopups: Dispatch<React.SetStateAction<PopupsListType[]>>;
  widthValue: number;
  setRiverSensorRender: () => void;
  removeItem: (id: string, type: ItemTypes) => void;
  addItem: (id: string, type: ItemTypes) => void;
  coordinatesPopup: Coordinate;
};

const columns: GridColDef[] = [
  { field: "id", headerName: "Id", flex: 1 },
  { field: "name", headerName: "Id", flex: 1 },
  { field: "value", headerName: "Value", flex: 1 },
  { field: "timestamp", headerName: "Timestamp", flex: 1 },
];

const RiverChartPopup = (props: SideMenuPopupsType) => {
  const { RiverOpenSidebarMap, removeFromRiverOpenSidebarMap } =
    useRiverContext();

  // Setup date
  const [setupDate, setSetupDate] = useState<SetupDateType | null>(null);
  // Selected gauges
  const [selectedGauges, setSelectedGauges] = useState<string[]>([]);
  // Selected tab
  const [selectedTab, setSelectedTab] = useState<string>("realtime_data_tab");
  // Sensor info open status
  const [isSensorInfoOpen, setIsSensorInfoOpen] = useState<boolean>(false);
  const [isLoadingModel, setIsLoadingModel] = useState<boolean>(true);
  const date = new Date().toLocaleDateString();
  const time = new Date().toLocaleTimeString();
  const [level, setLevel] = useState<number | null>(null);
  const [lastUpdate, setLastUpdate] = useState<string | null>(null);
  const [coordinates, setCoordinates] = useState<{
    latitude: number;
    longitude: number;
  } | null>(null);
  const [newRiverData, setNewRiverData] = useState<any>("");
  const [riverName, setRiverName] = useState<string>("");
  const [activeFullScreen, setActiveFullScreen] = useState<boolean>(false);
  const [selectedModel, setSelectedModel] = useState("LSTM"); // or your default

  const [dimensions, setDimensions] = useState({
    resizableBoxwidth: 0,
    resizableBoxheight: 0,
  });

  const [dimensionsMin, setDimensionsMin] = useState({
    resizableBoxMinwidth: 0,
    resizableBoxMinheight: 0,
  });

  const updateDimensions = () => {
    const vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    const vh = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    );

    if (vw > 2000 && vh > 1200) {
      setDimensions({
        resizableBoxwidth: vw * 0.4,
        resizableBoxheight: vh * 0.3,
      });
    } else {
      setDimensions({
        resizableBoxwidth: vw * 0.68,
        resizableBoxheight: vh * 0.8,
      });
    }

    if (vw > 2000 && vh > 1200) {
      setDimensionsMin({
        resizableBoxMinwidth: vw * 0.3,
        resizableBoxMinheight: vh * 0.4,
      });
    } else {
      setDimensionsMin({
        resizableBoxMinwidth: vw * 0.3,
        resizableBoxMinheight: vh * 0.4,
      });
    }
  };

  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  // const openContentFullscreen = () => {
  //   if (!document.fullscreenElement) {
  //     enterFullscreen();
  //     setShowSensorDetails(true);
  //   } else {
  //     exitFullScreen();
  //     setShowSensorDetails(false);
  //   }
  // };

  // const enterFullscreen = () => {
  //   const elem = fullscreenModal.current;
  //   if (elem) {
  //     if (elem.requestFullscreen) {
  //       elem.requestFullscreen();
  //     }
  //     setActiveFullScreen(true);
  //   }
  // };

  // const exitFullScreen = () => {
  //   if (document.exitFullscreen) {
  //     document.exitFullscreen();
  //   } else if ((document as any).mozCancelFullScreen) {
  //     (document as any).mozCancelFullScreen();
  //   } else if ((document as any).webkitExitFullscreen) {
  //     (document as any).webkitExitFullscreen();
  //   } else if ((document as any).msExitFullscreen) {
  //     (document as any).msExitFullscreen();
  //   }
  //   setActiveFullScreen(false);
  // };

  const [widthMain, setWidthMain] = useState<number>(0);
  const [heightMain, setHeightMain] = useState<number>(0);
  const RIVER_LEVEL_DATA_URL = process.env.REACT_APP_RIVER_LEVEL_DATA_URL;

  useEffect(() => {
    setWidthMain(props.widthValue);
  }, [props.widthValue, widthMain, heightMain]);

  // const handleResize = (
  //   event: React.SyntheticEvent,
  //   data: ResizeCallbackData
  // ) => {
  //   setWidthMain(data.size.width);
  //   setHeightMain(data.size.height);
  // };

  useEffect(() => {
    const fetchCurrentSensorsData = async () => {
      try {
        const response = await fetch(`${RIVER_LEVEL_DATA_URL}` + props.id);
        const responseData = await response.json();

        if (responseData && typeof responseData === "object") {
          const { level, time, coordinates } = responseData;
          setLevel(level);
          setLastUpdate(time);
          setCoordinates(coordinates);
        } else {
          console.error("Invalid response data format:", responseData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchCurrentSensorsData();
    return () => {};
  }, [props.id]);

  const NewRiverData = (data: any) => {
    setNewRiverData(data);
  };

  // Handle set time button click
  const handleSetTimeButtonClick = () => {
    const startTimeInputElement = document.getElementById(
      "side_menu_start_date_input"
    ) as HTMLInputElement;
    const endTimeInputElement = document.getElementById(
      "side_menu_end_date_input"
    ) as HTMLInputElement;

    if (startTimeInputElement && endTimeInputElement) {
      const tempTime: SetupDateType = {
        startDate: new Date(startTimeInputElement.value),
        endDate: new Date(endTimeInputElement.value),
      };

      setSetupDate((prevState) => tempTime);
    }
  };

  // Handle reset button click
  const handleResetButtonClick = () => {
    const startTimeInputElement = document.getElementById(
      "side_menu_start_date_input"
    ) as HTMLInputElement;
    const endTimeInputElement = document.getElementById(
      "side_menu_end_date_input"
    ) as HTMLInputElement;

    if (startTimeInputElement && endTimeInputElement) {
      setSetupDate((prevState) => null);
      startTimeInputElement.value = "";
      endTimeInputElement.value = "";
    }
  };

  // Handle gauges checkbox click
  const handleGaugeCheckBox = (
    event: ChangeEvent<HTMLInputElement>,
    name: string
  ) => {
    if (event.target.checked) {
      setSelectedGauges((prevState) => [...prevState, name]);
    } else {
      setSelectedGauges((prevState) =>
        prevState.filter((gauge) => gauge !== name)
      );
    }
  };

  const removeRiverById = (id: string) => {
    if (riverMap.has(id)) {
      riverMap.delete(id);
      openWindowsMapRiver.set(id, "close");
      props.setRiverSensorRender();
    }
    // removeFromRiverOpenSidebarMap(id);
    removeFromRiverOpenSidebarMap(id);
    if (RiverOpenSidebarMap.has(id)) {
      RiverOpenSidebarMap.delete(id);
    }
    removeOverlay(id);
  };

  useEffect(() => {
    const entries = Array.from(RiverOpenSidebarMap.values());
    const lastEntryIndex = entries.length - 1;
    entries.forEach((details, index) => {
      const { coordinates, sensorId } = details;
      if (coordinates) {
        removeOverlay(sensorId!);
        if (index === lastEntryIndex) {
          addOverlayClickItemLast(sensorId!, coordinates);
        } else {
          addOverlayClickItem(sensorId!, coordinates);
        }
      }
    });
  }, [RiverOpenSidebarMap.size]);

  const removeOverlay = (key: string) => {
    const overlays = map.getOverlays().getArray();
    const overlaysToRemove = overlays.filter(
      (overlay) => overlay.getId() === key
    );
    overlaysToRemove.forEach((overlay) => {
      map.removeOverlay(overlay);
    });
  };

  const addOverlayClickItem = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "location-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "location-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const addOverlayClickItemLast = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "locationlast-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "locationlast-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const [isNotRelease, setIsNotRelease] = useState<boolean>(true);

  const popupRef = useRef<HTMLDivElement | null>(null);
  const popupElement = document.createElement("earlyWarningElement");

  const mouseMoveEvent = useCallback(
    (event: MouseEvent) => {
      const sideMenu = document.getElementById("side-menu-wrapper");

      if (sideMenu && isNotRelease) {
        const sideMenuWidth = Number(
          window.getComputedStyle(sideMenu).left.slice(0, -2)
        );

        if (sideMenuWidth > event.clientX) {
          ReactDOM.render(
            <SensorsPopUp
              sensorId={props.id!}
              name={props.name!}
              cautionLevel={props.cautious!}
              warningLevel={props.warning!}
              criticalLevel={props.critical!}
              onClose={handleClose}
              addItem={props.addItem}
              id={props.id}
            />,
            popupElement
          );

          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });
          overlay.setPosition(props.coordinatesPopup);
          map.addOverlay(overlay);
          props.removeItem(props.id, "river");
          setIsNotRelease(false);
        }
      }
    },
    [isNotRelease]
  );

  const mouseMoveEventTouch = useCallback(
    (event: TouchEvent) => {
      const sideMenu = document.getElementById("side-menu-wrapper");

      if (sideMenu && isNotRelease) {
        const sideMenuWidth = Number(
          window.getComputedStyle(sideMenu).left.slice(0, -2)
        );

        const touchX = event.touches[0].clientX; // Get touch position

        if (sideMenuWidth > touchX) {
          ReactDOM.render(
            <SensorsPopUp
              sensorId={props.id!}
              name={props.name!}
              cautionLevel={props.cautious!}
              warningLevel={props.warning!}
              criticalLevel={props.critical!}
              onClose={handleClose}
              addItem={props.addItem}
              id={props.id}
            />,
            popupElement
          );

          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });
          overlay.setPosition(props.coordinatesPopup);
          map.addOverlay(overlay);
          props.removeItem(props.id, "river");
          setIsNotRelease(false);
        }
      }
    },
    [isNotRelease]
  );

  useEffect(() => {
    const handleMouseDown = () => {
      document.addEventListener("mousemove", mouseMoveEvent);
      document.addEventListener("mouseup", handleMouseUp);
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", mouseMoveEvent);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    const handleTouchStart = () => {
      document.addEventListener("touchmove", mouseMoveEventTouch);
      document.addEventListener("touchend", handleTouchEnd);
    };

    const handleTouchEnd = () => {
      document.removeEventListener("touchmove", mouseMoveEventTouch);
      document.removeEventListener("touchend", handleTouchEnd);
    };

    if (popupRef.current) {
      popupRef.current.addEventListener("mouseenter", () => {
        popupRef.current?.addEventListener("mousedown", handleMouseDown);
        popupRef.current?.addEventListener("touchstart", handleTouchStart);
      });
    }

    return () => {
      document.removeEventListener("mousemove", mouseMoveEvent);
      document.removeEventListener("mouseup", handleMouseUp);
      document.removeEventListener("touchmove", mouseMoveEventTouch);
      document.removeEventListener("touchend", handleTouchEnd);
    };
  }, [mouseMoveEvent, mouseMoveEventTouch]);

  const handleClose = (incidentId: string) => {
    openWindowsMapRiver.set(incidentId, "close");
    removeFromRiverOpenSidebarMap(incidentId);

    if (riverMap.has(incidentId)) {
      riverMap.delete(incidentId);
    }

    if (RiverOpenSidebarMap.has(incidentId)) {
      RiverOpenSidebarMap.delete(incidentId);
    }
  };

  const handleDataLoaded = (loaded: boolean) => {
    setIsLoadingModel(loaded);
  };

  useEffect(() => {}, [isLoadingModel]);
  

  const [value, setValues] = useState<
    { id: number; name: string; value: number; timestamp: string }[]>([]);

  const handleModelChange = (model:string) => {
      setSelectedModel(model);
    };
  
  useEffect(() => {}, [selectedModel]);

  return (
    <div className={`popup`}>
      <div className={`titleWrapper `} ref={popupRef}>
        <span>{props.name}</span>
        <div className={`titleButtonContainer no-drag`}>
          {/* <i className={`titleIcon fullScreenIco`}></i> */}
          <i
            className={`titleIcon closeIco`}
            onClick={(e) => {
              removeRiverById(props.id);
            }}
            onTouchStart={(e) => {
              removeRiverById(props.id);
            }}
          ></i>
        </div>
      </div>
      {/* Tab area */}
      <div className={`tabArea no-drag`}>
        <div
          className={`tabButton ${
            selectedTab === "realtime_data_tab" ? "tabSelected" : ""
          }`}
          id="realtime_data_tab"
          onClick={(e) => setSelectedTab((prevState) => "realtime_data_tab")}
          onTouchStart={(e) =>
            setSelectedTab((prevState) => "realtime_data_tab")
          }
        >
          realtime data
        </div>
        <div
          className={`tabButton ${
            selectedTab === "forecast_tab" ? "tabSelected" : ""
          }`}
          id="forecast_tab"
          onClick={(e) => {
            setSelectedTab((prevState) => "forecast_tab");
          }}
        >
          forecast
        </div>
      </div>

      {/* Data container */}
      {selectedTab === "realtime_data_tab" && (
        <>
          <div className={`popupDataWrapper`}>
            <div className={`gridCell mapWrapper no-drag`}>
              {/* <div
                className="no-drag"
                style={{
                  height: "100%",
                  width: "95%",
                  display: "flex",
                  alignItems: "start",
                  margin: "0px",
                  flexDirection: "column",
                  justifyContent: "top",
                }}
              > */}
              <SideRiverChart
                id={props.id}
                name={props.name}
                critical={props.critical}
                cautious={props.cautious}
                warning={props.warning}
                riverData={newRiverData}
                riverName={riverName}
                fullScreen={activeFullScreen}
                lastUpdate={lastUpdate}
                showDialog={true}
                dimensions={dimensions}
                chartWidth={
                  widthMain > 1000 ? widthMain * 0.7 : widthMain * 0.8
                }
                chartHeight={300}
              />
              {/* </div> */}
            </div>

            <div className={`gridCell menu1 no-drag`}>
              <span className={`title`}>Time</span>
              <div className={`sideMenu1DataContainer`}>
                {/* Display setup time */}
                <div className={`currentDateDisplayContainer`}>
                  {setupDate !== null ? (
                    <>
                      <span>
                        start time:
                        <span>
                          {new Date(setupDate.startDate).toLocaleString()}
                        </span>
                      </span>
                      <span>
                        end time:
                        <span>
                          {new Date(setupDate.endDate).toLocaleString()}
                        </span>
                      </span>
                    </>
                  ) : (
                    <span>last 72 days</span>
                  )}
                </div>
                {/* Display date inputs */}
                <div className={`inputContainer`}>
                  <label htmlFor="side_menu_start_date_input">start date</label>
                  <input
                    type="datetime-local"
                    id="side_menu_start_date_input"
                  />
                  <label htmlFor="side_menu_end_date_input">end date</label>
                  <input type="datetime-local" id="side_menu_end_date_input" />
                </div>
                {/* Display button container */}
                <div className={`buttonContainer`}>
                  <span
                    onClick={(e) => handleSetTimeButtonClick()}
                    onTouchStart={(e) => handleSetTimeButtonClick()}
                  >
                    <i className={`setTimeIco`}></i> set time
                  </span>
                  <span
                    onClick={(e) => handleResetButtonClick()}
                    onTouchStart={(e) => handleResetButtonClick()}
                  >
                    <i className={`setResetIco`}></i> reset
                  </span>
                </div>
              </div>
            </div>

            <div className={`gridCell menu2`}>
              <span className={`title`}>Gauges</span>
              <div className={`sideMenu2DataContainer no-drag`}>
                {/* Layer items */}
                <AvailableRiverSensors
                  sendNewRiverData={NewRiverData}
                  setSharedString={setRiverName}
                />
              </div>
            </div>
            {/* Sensor info expander */}
            <div
              className={`expander no-drag`}
              onClick={(e) => setIsSensorInfoOpen((prevState) => !prevState)}
              onTouchStart={(e) =>
                setIsSensorInfoOpen((prevState) => !prevState)
              }
            >
              <i
                className={`${
                  isSensorInfoOpen ? "expanderUp" : "expanderDown"
                }`}
              ></i>
              <span>sensor details</span>
            </div>
            {/* Color */}
            <div className={`gridCell colorWrapper`}>
              <div className={`legendItem`}>
                <i
                  className={`colorBox`}
                  style={{ backgroundColor: "#0275d8" }}
                ></i>
                <span>River level</span>
              </div>
              <div className={`legendItem`}>
                <i
                  className={`colorBox`}
                  style={{ backgroundColor: "#e4e736" }}
                ></i>
                <span>Cautious level</span>
              </div>
              <div className={`legendItem`}>
                <i
                  className={`colorBox`}
                  style={{ backgroundColor: "#eb9824" }}
                ></i>
                <span>Warning level</span>
              </div>
              <div className={`legendItem`}>
                <i
                  className={`colorBox`}
                  style={{ backgroundColor: "#d9534f" }}
                ></i>
                <span>Danger level</span>
              </div>
            </div>
            {/* Details */}
            <div className={`gridCell detailWrapper`}>
              <div className={`detailItem`}>
                <span className={`label`}>Date & Time: </span>
                <span className={`data`}>
                  {date}, {time}
                </span>
              </div>
              <div className={`detailItem`}>
                <span className={`label`}>Water Level: </span>
                <span className={`data`}>{level} m</span>
              </div>
              <div className={`detailItem`}>
                <span className={`label`}>Last Update: </span>
                <span className={`data`}>{lastUpdate}</span>
              </div>
            </div>
            {/* Sensor info */}
            {isSensorInfoOpen && (
              <div className={`sensorInfoContainer`}>
                <span className={`sensorInfoTitle`}>sensor info</span>
                <div className={`sensorInfoDataContainer`}>
                  <div className={`left`}>
                    <div className={"dataRow"}>
                      <span className={"name"}>Name</span>
                      <span className={"data"}>{props.name}</span>
                    </div>

                    <div className={"dataRow"}>
                      <span className={"name"}>Cautious Level</span>
                      <span className={"data"}>{props.cautious} m</span>
                    </div>
                    <div className={"dataRow"}>
                      <span className={"name"}>Warning Level</span>
                      <span className={"data"}>{props.warning} m</span>
                    </div>
                    <div className={"dataRow"}>
                      <span className={"name"}>Danger Level</span>
                      <span className={"data"}>{props.critical} m</span>
                    </div>
                  </div>
                  <div className={`right`}>
                    <RiverSensorLocation
                      coordinates={coordinates || { latitude: 0, longitude: 0 }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}

      {selectedTab === "forecast_tab" && (
        <>
        <label htmlFor="model-select" style={{color:"var(--text-color)"}}>Select Model: </label>
<select 
  id="model-select" 
  className="model-dropdown   no-drag"
  onChange={(e) => handleModelChange(e.target.value)}
  value={selectedModel}
  style={{
    padding: '8px 12px',
    borderRadius: '10px',
    border: '2px solid #ccc',
    backgroundColor: 'var(--menu-color)',
    fontSize: '12px',
    marginLeft: '10px',
    marginTop:'10px',
    cursor: 'pointer',
    width:'100px',
    color:'var(--text-color)'
  }}
>
  <option value="LSTM">LSTM</option>
  <option value="FNN">FNN</option>
</select>
{(selectedModel === "LSTM" || selectedModel === "FNN") && (<div className={`tabForecastContainer`}>

<div className={`forecastDataContainer no-drag`}>
  <div className={`gridCell chart`}>
    <ForcastChart
      id={props.id}
      name={props.name}
      critical={props.critical}
      cautious={props.cautious}
      warning={props.warning}
      riverData={newRiverData}
      riverName={riverName}
      fullScreen={activeFullScreen}
      lastUpdate={lastUpdate}
      showDialog={true}
      dimensions={dimensions}
      chartWidth={
        widthMain > 1000 ? widthMain * 0.7 : widthMain * 0.8
      }
      chartHeight={300}
      onDataLoaded={handleDataLoaded}
      predictValues={setValues}
      selectedModel={selectedModel}
    />
  </div>
  <div className={`gridCell table`}>
    <Paper sx={{ height: "100%", width: "100%" }}>
      <DataGrid
        rows={value}
        columns={columns}
        checkboxSelection={false}
        columnHeaderHeight={50}
        rowHeight={40}
        disableColumnFilter
        disableColumnSorting
        disableColumnMenu
        disableRowSelectionOnClick
        disableColumnResize
        columnVisibilityModel={{ id: false }}
        sx={{
          border: 0,
          backgroundColor: "var(--background-color)",
          color: "var(--text-color)" ,
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "var(--background-color)",
          },
          "& .MuiDataGrid-footerContainer": {
            display: "none", 
          },
        }}
      />
    </Paper>
  </div>
</div>
{isLoadingModel && (
  <div className={`forecast-model-loading`}>
    <img src={loadImageBlue} alt="" />
    <span>Loading River Level Predictions...</span>
    <span>
      Eagle-I AI models are analyzing real-time data. This may
      take a few moments.
    </span>
  </div>
)}
</div>)}
        </>

      )}
    </div>
  );
};

export default RiverChartPopup;
